import { createContext, useState, useContext, useEffect } from 'react';
import { useNavigate, useParams, useLocation, useSearchParams  } from 'react-router-dom'; 
import Step from '../Components/RegistrationApp/Step'
import Stepper from '../Components/RegistrationApp/Stepper'
import {AuthContext} from '../context/AuthContext'
import utilities from '../utilities'

export const FormContext = createContext();

const Apply = (props) => {
  const {userInfo} = useContext(AuthContext);
  const [activeStepIndex, setActiveStepIndex] = useState(0);
  const [formData, setFormData] = useState({});
  let { registrationID } = useParams();

  

  useEffect(  () => {

    const getApplicationData = async () => {
      if(registrationID)
      {
        const rID = utilities.decryptData(registrationID); 
        const application = await utilities.getAsyncData( {url: '/Registration/GetAppliationByID?RegistrationID=' + rID, jwt: userInfo.jwt} );
        const data = { ...formData, ...application };
        setFormData(data);
      }
    }
    
    getApplicationData();

}, []);


  return (
    <FormContext.Provider
      value={{ activeStepIndex, setActiveStepIndex, formData, setFormData }}>
        <div className="container vh-100">
          <div className="row vh-100 justify-content-center" >
             <div className="" style={{border:'1px solid lightgray', padding: '25px', borderRadius: 10, background: 'white'}}>
             <Stepper />
             <Step />
            </div>
          </div>
        </div>
    </FormContext.Provider>
  );
}

export default Apply;